import {
    Dispatch,
    SetStateAction
} from "react";
import {
    Drawer,
    useMediaQuery
} from "@mui/material";

import { SidebarDrawerContents } from "./contents/SidebarDrawerContent";
import theme from "../../assets/style/theme";

type SidebarDrawerProps = {
    open: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const SMALL_DRAWER_WIDTH = 280;
const LARGE_DRAWER_WIDTH = 320;

export const SidebarDrawer = (props: SidebarDrawerProps) => {
    const { open, setIsOpen } = props;
    const isSmallerThanMd = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Drawer
            open={open}
            onClose={() => setIsOpen(false)}
            variant={isSmallerThanMd ? "temporary" : "permanent"}
            ModalProps={{
                keepMounted: isSmallerThanMd ? true : undefined,
            }}
            sx={{
                "& .MuiDrawer-paper": {
                    ...(isSmallerThanMd ? {
                        boxSizing: "border-box",
                        width: SMALL_DRAWER_WIDTH
                    } : {
                        position: "fixed", // This is what keeps the sidebar overlayed "on top" of the content instead of shifting it.
                        whiteSpace: "nowrap",
                        width: LARGE_DRAWER_WIDTH,
                        transition: theme => theme.transitions.create('width', {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                        boxSizing: "border-box",
                        ...(!open && {
                            overflowX: "hidden",
                            transition: theme => theme.transitions.create('width', {
                                easing: theme.transitions.easing.sharp,
                                duration: theme.transitions.duration.leavingScreen,
                            }),
                            width: theme => ({ xs: theme.spacing(7), md: theme.spacing(9) }),
                        })
                    })
                },
            }}
        >
            <SidebarDrawerContents isOpen={open} setIsOpen={setIsOpen} />
        </Drawer>
    );
};
